(function () {
    class EditExistingUserModalController {
        constructor(
            $scope,
            $uibModalInstance,
            userId,
            firstName,
            lastName,
            manageUserById,
            resetEmailInput
        ) {
            this.modalInstance = $uibModalInstance;
            $scope.userId = userId;
            $scope.firstName = firstName;
            $scope.lastName = lastName;
            $scope.confirm = function() {
                $uibModalInstance.close(true);
                manageUserById(userId)
            }
            $scope.cancel = function() {
                $uibModalInstance.close(false);
                resetEmailInput()
            }
        }
    }

    angular
        .module('dashboard')
        .controller('EditExistingUserModalController', [
            '$scope',
            '$uibModalInstance',
            'userId',
            'firstName',
            'lastName',
            'manageUserById',
            'resetEmailInput',
            EditExistingUserModalController
        ]);
})();
